const firebaseConfig = {
  apiKey: 'AIzaSyBP8i2MZ62pJ-T9wI_ROfHAiG1Xn728Kzs',
  authDomain: 'askaway-react-dev.firebaseapp.com',
  projectId: 'askaway-react-dev',
  storageBucket: 'askaway-react-dev.appspot.com',
  messagingSenderId: '369883632878',
  appId: '1:369883632878:web:2a5ce7653d707471338fff',
};

export default firebaseConfig;
